export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 100;
export const PASSWORD_SPECIAL_CHARS_REGEX = /[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~\\]/;
